import React from 'react';
import { RestaurantCustomerReview } from '../../services/restaurantService';
import { FooterRatingStars } from '../Footer/FooterIcons';
import '../Footer/footerIcons.css';
import './CustomerReviewList.css';

interface CustomerReviewListProps {
  reviews: RestaurantCustomerReview[];
  emptyMessage?: string;
}

const CustomerReviewList: React.FC<CustomerReviewListProps> = ({
  reviews,
  emptyMessage = 'No customer reviews yet.',
}) => {
  if (reviews.length === 0) {
    return <p className="cr-empty">{emptyMessage}</p>;
  }

  return (
    <ul className="cr-list">
      {reviews.map((review) => {
        const rating = Number(review.rating);
        const safeRating = Number.isFinite(rating) ? Math.min(5, Math.max(0, rating)) : 0;

        return (
          <li key={review.id} className="cr-item">
            <div className="cr-item-top">
              <FooterRatingStars rating={safeRating} className="cr-item-stars" />
              {review.submittedOn && <span className="cr-date">{review.submittedOn}</span>}
            </div>
            <div className="cr-item-meta">
              <span className="cr-author">{review.userName}</span>
              {review.verifiedPurchase && (
                <span className="cr-verified">Verified purchase</span>
              )}
            </div>
            {review.comment?.trim() && <p className="cr-comment">{review.comment.trim()}</p>}
          </li>
        );
      })}
    </ul>
  );
};

export default CustomerReviewList;
